import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import { ILinkedChecklistResultProject } from './ILinkedChecklistResultProject'

export class LinkedChecklistResultProject extends Entity<ILinkedChecklistResultProject> {
  id: number

  name: string

  timezone: string

  public static new(payload: unknown): LinkedChecklistResultProject {
    const entity = plainToInstance(LinkedChecklistResultProject, payload)

    return entity
  }
}
